/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */
import "../src/styles/global.css";
import "../src/styles/text.scss";
import "prismjs/themes/prism.css";
import "../src/styles/prism-okaidia.scss";
